export default "__VITE_ASSET__CuAsME0n__"